import { qs, qsa } from "../inc/dom.js";

const initSearch = () => {
    const search = qs("[data-vg-search]");
    if (!search) return;
    const form = qs("[data-vg-searchform]");
    const items = qsa("[data-vg-item]");
    if (!items.length) return;
    const sections = qsa("[data-page-section]");
    const empty = qs("[data-vg-empty]");

    const render = () => {
        const term = search.value.trim().toLowerCase();
        let shown = 0;
        items.forEach((item) => {
            const visible = !term || (item.dataset.vgName || "").includes(term);
            const slide = item.closest(".swiper-slide");
            if (slide) slide.hidden = !visible;
            if (visible) shown += 1;
        });
        sections.forEach((section) => {
            const visible = qsa(".swiper-slide:not([hidden])", section).length > 0;
            section.hidden = !visible;
            const track = qs("[data-bleed-slider-track]", section);
            if (visible && track && track.swiper) track.swiper.update();
        });
        if (empty) empty.hidden = shown !== 0;
    };

    if (form) form.addEventListener("submit", (event) => event.preventDefault());
    search.addEventListener("input", render);
    render();
};

const copyToClipboard = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(value);
            return true;
        } catch (e) {}
    }
    const field = document.createElement("textarea");
    field.value = value;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.select();
    let copied = false;
    try {
        copied = document.execCommand("copy");
    } catch (e) {
        copied = false;
    }
    document.body.removeChild(field);
    return copied;
};

const initShare = () => {
    qsa("[data-vg-share]").forEach((button) => {
        const label = button.querySelector("span");
        button.addEventListener("click", async (event) => {
            event.preventDefault();
            const url = button.dataset.vgShare;
            if (!url) return;
            if (navigator.share) {
                try {
                    await navigator.share({ url });
                    return;
                } catch (e) {
                    if (e && e.name === "AbortError") return;
                }
            }
            const copied = await copyToClipboard(url);
            if (!copied || !label || button.classList.contains("is-copied")) return;
            const original = label.textContent;
            label.textContent = "Copied";
            button.classList.add("is-copied");
            setTimeout(() => {
                label.textContent = original;
                button.classList.remove("is-copied");
            }, 2000);
        });
    });
};

initSearch();
initShare();
